import { BodyContainer } from '../BlogContent';

export interface Props {
  content: string;
}

export default function Component(props: Props) {
  return <BodyContainer dangerouslySetInnerHTML={{ __html: props.content }} />;
}
